import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import { useAuthContext } from "../../../hooks/useAuthContext";
import trainingsAPI from "../../../services/trainings";
import AgendaEventsComponent from "../../trainings/events/components/AgendaEventsComponent";

const SecretariatAgendaDetailPage = () => {
  const { auth } = useAuthContext();
  const { schoolId, trainingId } = useParams();
  const navigate = useNavigate();

  const trainingQuery = trainingsAPI.GetOne(schoolId, trainingId, auth?.access_token);
  const training = trainingQuery?.data?.data;

  return (
    <MeaPage
      title="Agenda"
      subtitle={training ? `Événements de la formation ${training.name}` : "Événements de la formation"}
      breadcrumb={<SecretariatWorkspaceBar section="agenda" training={training} />}
      showBackButton={true}
      onBackButtonClick={() => navigate(`/school/${schoolId}/secretariat`)}
    >
      <div className="px-3 md:px-5">
        <AgendaEventsComponent
          key={trainingId}
          schoolId={schoolId}
          trainingId={trainingId}
          accessToken={auth?.access_token}
        />
      </div>
    </MeaPage>
  );
};

export default SecretariatAgendaDetailPage;
